// extracted by mini-css-extract-plugin
module.exports = {"loadingMessageContainer":"HotelBlock_loadingMessageContainer__-b6Qr","iconSync":"HotelBlock_iconSync__xk0Y6","fa-spin":"HotelBlock_fa-spin__CIPd_"};